import React from "react";
import { ShieldAlert } from "lucide-react";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogAction,
} from "./ui/alert-dialog";

export const SessionExpiredDialog = ({ open, onSignIn }) => (
  <AlertDialog open={open}>
    <AlertDialogContent
      data-testid="session-expired-dialog"
      onEscapeKeyDown={(e) => e.preventDefault()}
    >
      <AlertDialogHeader>
        <div className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-amber-100 text-amber-700">
            <ShieldAlert className="h-5 w-5" />
          </span>
          <AlertDialogTitle data-testid="session-expired-title">
            Your session has expired
          </AlertDialogTitle>
        </div>
        <AlertDialogDescription data-testid="session-expired-message">
          Your connection to Blexbot has timed out, so live price updates are paused.
          Please sign in again with your WhatsApp code to continue.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogAction data-testid="session-expired-signin-btn" onClick={onSignIn}>
          Sign in again
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
